/* Reformly Home — scroll reveal.

   Mirrors the export: observe every [data-rhm-reveal], flip it to "in" on
   intersection, then unobserve so it fires once. Scrolling back up does not
   re-hide anything.

   Loaded once by layout-level inclusion rather than per section, and guarded
   so a second copy is a no-op: the home page emits 15 sections and each one
   asking for its own observer would mean 15 observers watching one element
   each.

   FAIL-OPEN is the important part. The CSS starts these elements at
   opacity: 0, so if this script does not run — blocked, errored, or
   IntersectionObserver missing — the entire page is invisible, not merely
   unanimated. Every path below therefore ends with the content shown.
*/
(function () {
  if (window.__rhmReveal) return;
  window.__rhmReveal = true;

  var SEL = '[data-rhm-reveal]';

  function showAll() {
    var els = document.querySelectorAll(SEL);
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-rhm-reveal', 'in');
    });
  }

  /* No observer support, or the user asked for less motion: show everything
     immediately and do no further work. */
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || (rm && rm.matches)) {
    showAll();
    return;
  }

  var io;
  try {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.setAttribute('data-rhm-reveal', 'in');
        io.unobserve(en.target);
      });
    }, {
      /* A little before the element's top edge arrives, so the fade is
         finishing as it enters rather than starting. */
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });
  } catch (e) {
    showAll();
    return;
  }

  function observe() {
    var els = document.querySelectorAll(SEL + ':not([data-rhm-reveal="in"])');
    Array.prototype.forEach.call(els, function (el) {
      if (el.__rhmObserved) return;
      el.__rhmObserved = true;
      io.observe(el);
    });
  }

  observe();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  }

  /* Theme editor: re-rendering a section replaces its DOM, so the new nodes
     are unobserved and would sit at opacity 0 forever. */
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:select', showAll);

  /* Last resort. If anything above silently failed to catch a section — a
     section below the fold inside a container that never intersects, for
     instance — this guarantees the page is readable rather than blank. */
  window.setTimeout(showAll, 4000);
})();
